const _excluded = ["label", "dataId", "disabled", "required", "options", "placeholder", "maxItemsOverlay", "mapSelectedOptionToValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useController } from 'react-hook-form';
import { Dropdown } from '../../Dropdown';
import { FormField } from '../../FormField';
import { jsx as _jsx } from "react/jsx-runtime";
export const ControlledDropdown = _ref => {
  let {
      label,
      dataId,
      disabled,
      required,
      options,
      placeholder = '',
      maxItemsOverlay = 7,
      mapSelectedOptionToValue
    } = _ref,
    controllerProps = _objectWithoutProperties(_ref, _excluded);
  const {
    field: {
      onChange,
      value
    },
    fieldState: {
      error
    }
  } = useController(_objectSpread({}, controllerProps));
  const handleChange = opt => onChange(mapSelectedOptionToValue(opt));
  return /*#__PURE__*/_jsx(FormField, {
    errorMessages: error !== null && error !== void 0 && error.message ? [error.message] : [],
    label: label,
    required: required,
    children: /*#__PURE__*/_jsx(Dropdown, {
      dataId: dataId,
      maxItemsOverlay: maxItemsOverlay,
      options: options,
      disabled: disabled,
      placeholder: placeholder,
      onChange: (_event, option) => {
        if (!option) return;
        handleChange(option);
      },
      selectedKey: value
    })
  });
};